// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_auto_creation_rule_model.proto.
 */
export const file_bffuser_v1_workflow_auto_creation_rule_model: GenFile = /*@__PURE__*/
  fileDesc("CjJiZmZ1c2VyL3YxL3dvcmtmbG93X2F1dG9fY3JlYXRpb25fcnVsZV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSLgAQojV29ya2Zsb3dBdXRvQ3JlYXRpb25TY2hlZHVsZVRyaWdnZXISEgoKbGVhZF92YWx1ZRgBIAEoBRI7CglsZWFkX3VuaXQYAiABKA4yKC5iZmZ1c2VyLnYxLldvcmtmbG93QXV0b0NyZWF0aW9uTGVhZFVuaXQSKQoJZmlyZV90aW1lGAMgASgLMhYuZ29vZ2xlLnR5cGUuVGltZU9mRGF5Ej0KCmRheV9maWx0ZXIYBCABKA4yKS5iZmZ1c2VyLnYxLldvcmtmbG93QXV0b0NyZWF0aW9uRGF5RmlsdGVyIrsCChhXb3JrZmxvd0F1dG9DcmVhdGlvblJ1bGUSCgoCaWQYASABKAkSHAoUd29ya2Zsb3dfdGVtcGxhdGVfaWQYAiABKAkSKAoJYXJlYV9jb2RlGAMgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSDwoHZW5hYmxlZBgEIAEoCBJDCghzY2hlZHVsZRgKIAEoCzIvLmJmZnVzZXIudjEuV29ya2Zsb3dBdXRvQ3JlYXRpb25TY2hlZHVsZVRyaWdnZXJIABIuCgpjcmVhdGVkX2F0GBUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GBcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIJCgd0cmlnZ2VySgQIFBAVSgQIFhAXKtEBChxXb3JrZmxvd0F1dG9DcmVhdGlvbkxlYWRVbml0EjAKLFdPUktGTE9XX0FVVE9fQ1JFQVRJT05fTEVBRF9VTklUX1VOU1BFQ0lGSUVEEAASKAokV09SS0ZMT1dfQVVUT19DUkVBVElPTl9MRUFEX1VOSVRfREFZEAESKgomV09SS0ZMT1dfQVVUT19DUkVBVElPTl9MRUFEX1VOSVRfTU9OVEgQAhIpCiVXT1JLRkxPV19BVVRPX0NSRUFUSU9OX0xFQURfVU5JVF9ZRUFSEAMq9gEKHVdvcmtmbG93QXV0b0NyZWF0aW9uRGF5RmlsdGVyEjEKLVdPUktGTE9XX0FVVE9fQ1JFQVRJT05fREFZX0ZJTFRFUl9VTlNQRUNJRklFRBAAEi8KK1dPUktGTE9XX0FVVE9fQ1JFQVRJT05fREFZX0ZJTFRFUl9FVkVSWV9EQVkQARIuCipXT1JLRkxPV19BVVRPX0NSRUFUSU9OX0RBWV9GSUxURVJfV0VFS0RBWVMQAhJBCj1XT1JLRkxPV19BVVRPX0NSRUFUSU9OX0RBWV9GSUxURVJfV0VFS0RBWVNfRVhDTFVESU5HX0hPTElEQVlTEANCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_google_protobuf_timestamp, file_google_type_timeofday]);

/**
 * WorkflowAutoCreationScheduleTrigger holds the inputs of a 定期 (scheduled)
 * rule. The target-date cadence is derived from the template's section and
 * is not stored on the rule.
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationScheduleTrigger
 */
export type WorkflowAutoCreationScheduleTrigger = Message<"bffuser.v1.WorkflowAutoCreationScheduleTrigger"> & {
  /**
   * 起票リード. Non-negative; 0 means the target date itself.
   *
   * @generated from field: int32 lead_value = 1;
   */
  leadValue: number;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationLeadUnit lead_unit = 2;
   */
  leadUnit: WorkflowAutoCreationLeadUnit;

  /**
   * 起票時刻 in JST, minute precision (seconds and nanos are 0).
   *
   * @generated from field: google.type.TimeOfDay fire_time = 3;
   */
  fireTime?: TimeOfDay;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationDayFilter day_filter = 4;
   */
  dayFilter: WorkflowAutoCreationDayFilter;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationScheduleTrigger.
 * Use `create(WorkflowAutoCreationScheduleTriggerSchema)` to create a new message.
 */
export const WorkflowAutoCreationScheduleTriggerSchema: GenMessage<WorkflowAutoCreationScheduleTrigger> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 0);

/**
 * WorkflowAutoCreationRule is a 自動起票ルール that creates workflows
 * automatically: one scheduled rule per template × area × lead (lead_value,
 * lead_unit).
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationRule
 */
export type WorkflowAutoCreationRule = Message<"bffuser.v1.WorkflowAutoCreationRule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workflow_template_id = 2;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * 起票の合図. Only 定期 (schedule) exists until event-triggered creation
   * (AC-WFT-024) is provided.
   *
   * @generated from oneof bffuser.v1.WorkflowAutoCreationRule.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTrigger schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTrigger;
    case: "schedule";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 23;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationRule.
 * Use `create(WorkflowAutoCreationRuleSchema)` to create a new message.
 */
export const WorkflowAutoCreationRuleSchema: GenMessage<WorkflowAutoCreationRule> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 1);

/**
 * WorkflowAutoCreationLeadUnit is the unit of the 起票リード (how many days /
 * months / years before the target date a workflow is created).
 *
 * @generated from enum bffuser.v1.WorkflowAutoCreationLeadUnit
 */
export enum WorkflowAutoCreationLeadUnit {
  /**
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 日
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_DAY = 1;
   */
  DAY = 1,

  /**
   * 月
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_MONTH = 2;
   */
  MONTH = 2,

  /**
   * 年
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_YEAR = 3;
   */
  YEAR = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowAutoCreationLeadUnit.
 */
export const WorkflowAutoCreationLeadUnitSchema: GenEnum<WorkflowAutoCreationLeadUnit> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 0);

/**
 * WorkflowAutoCreationDayFilter is the 曜日フィルター of a scheduled rule.
 *
 * @generated from enum bffuser.v1.WorkflowAutoCreationDayFilter
 */
export enum WorkflowAutoCreationDayFilter {
  /**
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 毎日
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_EVERY_DAY = 1;
   */
  EVERY_DAY = 1,

  /**
   * 平日のみ
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_WEEKDAYS = 2;
   */
  WEEKDAYS = 2,

  /**
   * 平日祝日除く
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_WEEKDAYS_EXCLUDING_HOLIDAYS = 3;
   */
  WEEKDAYS_EXCLUDING_HOLIDAYS = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowAutoCreationDayFilter.
 */
export const WorkflowAutoCreationDayFilterSchema: GenEnum<WorkflowAutoCreationDayFilter> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 1);

